import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';

import { white } from '../../../../constants/color';
import { IMAGE_SPACE } from '../styles';

export const S = {
  Container: styled.View`
    height: 100%;
    background-color: ${white};
  `,
  ImagesContainer: styled.View`
    margin-top: 7px;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
    flex: 1;
  `,
};

export default StyleSheet.create({
  secondaryBox: {
    marginTop: 4,
  },
  imgBoxStyle: {
    marginRight: IMAGE_SPACE,
  },
});
